import type {
  ApplyReuseRequest,
  ApplyReuseResponse,
  ReusableComponentType,
  ReuseAvailabilityResponse,
} from "@repo/shared/types";
import { get, post } from "../_client";

const BASE = "/internal/flow-instances";

/** QL-505 — `subjectId` addresses one party when several answer (a group member, or a representative when 2+ are registered). */
export function getAvailability(
  instanceId: string,
  componentType: ReusableComponentType,
  subjectId?: string,
) {
  const memberQuery = subjectId ? `&subjectId=${encodeURIComponent(subjectId)}` : "";
  return get<ReuseAvailabilityResponse>(
    `${BASE}/${instanceId}/reuse-previous-answer?componentType=${componentType}${memberQuery}`,
  );
}

/** QL-505 — `subjectId` addresses one party when several answer (a group member, or a representative when 2+ are registered). */
export function applyPreviousAnswer(
  instanceId: string,
  componentType: ReusableComponentType,
  subjectId?: string,
) {
  return post<ApplyReuseResponse>(`${BASE}/${instanceId}/reuse-previous-answer`, {
    componentType,
    ...(subjectId ? { subjectId } : {}),
  } satisfies ApplyReuseRequest);
}
